/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateVehicle200Response
 */
export interface CreateVehicle200Response {
    /**
     * 車両ID
     * @type {string}
     * @memberof CreateVehicle200Response
     */
    carId: string;
}

/**
 * Check if a given object implements the CreateVehicle200Response interface.
 */
export function instanceOfCreateVehicle200Response(value: object): value is CreateVehicle200Response {
    if (!('carId' in value) || value['carId'] === undefined) return false;
    return true;
}

export function CreateVehicle200ResponseFromJSON(json: any): CreateVehicle200Response {
    return CreateVehicle200ResponseFromJSONTyped(json, false);
}

export function CreateVehicle200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateVehicle200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'carId': json['car_id'],
    };
}

export function CreateVehicle200ResponseToJSON(json: any): CreateVehicle200Response {
    return CreateVehicle200ResponseToJSONTyped(json, false);
}

export function CreateVehicle200ResponseToJSONTyped(value?: CreateVehicle200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'car_id': value['carId'],
    };
}

